module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/banner02-b95dc91303c2fe2a7af9538a759b6d5a.png";